<p-panel>
    <ng-template pTemplate="header">
        <div><h4>Notes</h4></div>
        <div class="flex flex-auto justify-content-end gap-2 align-items-center">
            <p-multiSelect [(ngModel)]="selectedCategoryFilter" [options]="categoryFilterOptions" optionLabel="label" optionValue="value"
                           placeholder="Filter by Category" [style]="{'min-width':'12rem'}"></p-multiSelect>
            <p-button icon="pi pi-plus" label="New" [text]="true"  (onClick)="resetNewNote(); newNoteVisible = true"></p-button>
            <p-button icon="pi pi-list" label="Show Note Log" [text]="true"  (onClick)="noteLog.toggle($event)"></p-button>
            <p-dialog
                appResizableDialog
                appendTo="body"
                [(visible)]="newNoteVisible"
                [modal]="true"
                [resizable]="false"
                [closable]="false"
                [closeOnEscape]="false"
                [dismissableMask]="false"
                styleClass="note-editor-dialog"
                header="New Note"
                [style]="{width: '75vw', height:'75vh'}"
                [contentStyle]="{'overflow-y': 'auto'}">
                <app-note-editor #newNoteEditor (click)="$event.stopPropagation()" (saved)="addNote($event); newNoteVisible = false" (cancelled)="newNoteVisible = false"></app-note-editor>
            </p-dialog>
            <p-overlayPanel appendTo="body" #noteLog [style]="{width: '85vw', height:'85vh'}" styleClass="overflow-y-scroll">
                <div *ngFor="let note of sortedNotes; let i = index">
                    <p-divider align="right" >
                        <p-tag icon="pi pi-user" [rounded]="true" [value]="note.createdBy.fullName"/>
                        <p-tag severity="secondary" icon="pi pi-calendar-clock" [rounded]="true" [value]="(note.createDate | date : 'short') ?? undefined"/>
                    </p-divider>
                    <div>Subject: <b>{{note.subject}}</b></div>
                    <div [innerHtml]="getSafeHtml(note)"></div>
                    <ng-container *ngFor="let addendum of note.addenda">
                        <p-divider align="left" type="dashed">
                            <p-tag severity="warning" icon="pi pi-pencil" [rounded]="true" value="Addendum"/>
                            <p-tag icon="pi pi-user" [rounded]="true" [value]="addendum.createdBy.fullName"/>
                            <p-tag severity="secondary" icon="pi pi-calendar-clock" [rounded]="true" [value]="(addendum.createDate | date : 'short') ?? undefined"/>
                        </p-divider>
                        <div [innerHtml]="getSafeHtml(addendum)"></div>
                    </ng-container>
                </div>
            </p-overlayPanel>
        </div>
    </ng-template>
    <div class="flex flex-column overflow-y-scroll">
        <p-table [value]="sortedNotes" [paginator]="sortedNotes.length > 5" [rows]="5">
            <ng-template pTemplate="header">
                <tr>
                    <th>Subject</th>
                    <th>Category</th>
                    <th>Created By</th>
                    <th>Create Date</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-note>
                <tr>
                    <td>
                        <i class="pi mr-1"
                           [class.pi-star-fill]="isSticky(note)"
                           [class.pi-star]="!isSticky(note)"
                           [class.text-yellow-500]="isSticky(note)"
                           [class.text-400]="!isSticky(note)"
                           (click)="toggleSticky(note)"
                           [pTooltip]="isSticky(note) ? 'Unmark Sticky' : 'Mark Sticky'"></i>
                        <span>{{note.subject}}</span>
                        <p-tag *ngIf="note.addenda?.length" severity="warning" [value]="note.addenda.length.toString()" [rounded]="true" styleClass="ml-2 text-xs"></p-tag>
                    </td>
                    <td>
                        <p-tag *ngIf="categoryLabel(note)" severity="info" [rounded]="true" [value]="categoryLabel(note)"></p-tag>
                    </td>
                    <td>
                        <p-tag icon="pi pi-user" [rounded]="true" [value]="note.createdBy.fullName"/>
                    </td>
                    <td>
                        <p-tag severity="secondary" icon="pi pi-calendar-clock" [rounded]="true" [value]="(note.createDate | date : 'short') ?? undefined"/>
                    </td>
                    <td class="flex gap-1">
                        <p-button icon="pi pi-eye" label="View" [text]="true" (onClick)="openViewNote(note)"></p-button>
                        <ng-container *ngIf="canEditNote(note)">
                            <p-button icon="pi pi-pencil" label="Edit" [text]="true" severity="warning" (onClick)="openEditNote(note)"></p-button>
                        </ng-container>
                        <ng-container *ngIf="canAddAddendum(note)">
                            <p-button icon="pi pi-plus" label="Add Addendum" [text]="true" severity="warning" (onClick)="openAddendum(note)"></p-button>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-panel>

<p-dialog
    [modal]="true"
    appendTo="body"
    [(visible)]="viewNoteVisible"
    [maximizable]="true"
    styleClass="custom-note-dialog"
    [style]="{width: '85vw', height: '85vh'}"
    [contentStyle]="{'overflow-y': 'auto', 'height': 'calc(100% - 1rem)'}"
    (onHide)="viewNote = null">
        <ng-template pTemplate="header">
            <span><strong>Subject:</strong> {{viewNote?.subject}}</span>
        </ng-template>
        <div (click)="$event.stopPropagation()">
            <div *ngIf="viewNote" class="flex flex-column gap-3">
                <div class="grid">
                    <div class="col-3 white-space-nowrap"><strong>Type:</strong> {{getPrimaryNoteTypeLabel(viewNote.noteTypes)}}</div>
                    <div class="col-4 white-space-nowrap">Created by <strong>{{viewNote.createdBy?.fullName}}</strong> on <strong>{{viewNote?.createDate | date : 'medium'}}</strong></div>
                </div>
            </div>
            <p-divider></p-divider>
            <div class="note-body" [innerHtml]="getSafeHtml(viewNote)"></div>
            <ng-container *ngFor="let addendum of viewNote?.addenda">
                <p-divider align="left" type="dashed">
                    <p-tag severity="warning" icon="pi pi-pencil" [rounded]="true" value="Addendum"/>
                    <p-tag icon="pi pi-user" [rounded]="true" [value]="addendum.createdBy.fullName"/>
                    <p-tag severity="secondary" icon="pi pi-calendar-clock" [rounded]="true" [value]="(addendum.createDate | date : 'short') ?? undefined"/>
                </p-divider>
                <div class="note-body" [innerHtml]="getSafeHtml(addendum)"></div>
            </ng-container>
        </div>
</p-dialog>

<p-dialog
    appResizableDialog
    appendTo="body"
    [(visible)]="editNoteVisible"
    [modal]="true"
    [resizable]="false"
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    styleClass="note-editor-dialog"
    header="Edit Note"
    [style]="{width: '75vw', height:'75vh'}"
    [contentStyle]="{'overflow-y': 'auto'}">
    <app-note-editor
        [note]="editingNote"
        [editingNote]="true"
        (click)="$event.stopPropagation()"
        (saved)="updateNote($event); editNoteVisible = false"
        (deleted)="deleteNote($event); editNoteVisible = false"
        (cancelled)="editNoteVisible = false">
    </app-note-editor>
</p-dialog>

<p-dialog
    appResizableDialog
    appendTo="body"
    [(visible)]="addendumVisible"
    [modal]="true"
    [resizable]="false"
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    styleClass="note-editor-dialog"
    header="Add Addendum"
    [style]="{width: '50vw', height: '60vh'}"
    [contentStyle]="{'overflow-y': 'auto'}"
    (onHide)="addendumNote = null">
    <app-note-editor
        [addendumMode]="true"
        [addendumNote]="addendumNote ?? undefined"
        (click)="$event.stopPropagation()"
        (addendumSaved)="addAddendum($event); addendumVisible = false"
        (cancelled)="addendumVisible = false">
    </app-note-editor>
</p-dialog>
